import React, { useState } from "react";
import { VisibilityIcon,  VisibilityOffIcon} from '../../data/icons';
import { useNavigate } from "react-router-dom";
import  axios  from "axios";
import { url } from "../../data/url";

const EmployerSignIn = ({handleServerError, handleForgotPasswordClick}) => {
  const [showPassword, setShowPassword] = useState(false);
  const history = useNavigate();

  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
    userType: "employer",
    forgetPassword: false,
  });
  const [formErrors, setFormErrors] = useState({
    email: "",
    password: "",
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setFormErrors({
      ...formErrors,
      [name]: '',
    });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  axios.defaults.withCredentials = true;

  const handleSubmit = async (event) => {
    event.preventDefault();
    handleServerError("");
    if (validateForm()) {
      setIsLoading(true);
      try {
        const response = await axios.post(`${url.path}/signin`, formData, {
          withCredentials: true
        });
        const data = await response.data;

        if (response.status === 200) {
          resetForm();
          history("/employer");
        } else {
          handleServerError(data.message || "An error occurred during signin");
        }
      } catch (error) {
        if(error.response && error.response.status === 401) {
          handleServerError('Invalid credentials');
        }
        else if(error.response && error.response.status === 404) {
          handleServerError('Email does not exist, redirect to signup');
        }
        else {
        console.error('Error during signin:', error);
        handleServerError('An error occurred. Please try again later.');
        }
      } finally {
        setIsLoading(false);
      }
    } else {
      console.log('Form contains errors. Cannot submit.');
    }
  };

  const validateForm = () => {
    let valid = true;
    const errors = {};

    if (!formData.email.includes('@')) {
      errors.email = 'Invalid email format';
      valid = false;
    }

    setFormErrors(errors);
    return valid;
  };

  const resetForm = () => {
    setFormData({
      email: '',
      password: '',
      userType: "employer",
      forgetPassword: false,
    });
    setFormErrors({
      email: '',
      password: '',
    });
  };

  return (

    <form onSubmit={handleSubmit}>
    <div className="input-group">
        <input
        type="email"
        name="email"
        placeholder="Email"
        value={formData.email}
        onChange={handleInputChange}
        required
        />
        {formErrors.email && <span className="error">{formErrors.email}</span>}
    </div>
    <div className="input-group">
        <div className="password-group">
        <div className="password-group-container">
        <input
            type={showPassword ? 'text' : 'password'}
            id="password"
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleInputChange}
            required
        />
        <span 
            className="visibility-icon" 
            onClick={() => togglePasswordVisibility('password')}
            >
            {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
            </span>
            </div>
        {formErrors.password && <span className="error">{formErrors.password}</span>}
        </div>
    </div>
    {/* <div className="links forget-password">
        <span onClick={handleForgotPasswordClick} style={{ cursor: 'pointer', color: "#131111" }}><strong>Forgot Password?</strong></span>
    </div> */}
    <button type="submit" disabled={isLoading}>
        {isLoading ? 'Signing In...' : 'Sign In'}
      </button>
    </form>
  );
};

export default EmployerSignIn;
